"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", { value: true });
exports.createAWSCredentialsAndIdentityIdProvider = exports.createUserPoolsTokenProvider = void 0;
var createUserPoolsTokenProvider_1 = require("./createUserPoolsTokenProvider");
Object.defineProperty(exports, "createUserPoolsTokenProvider", { enumerable: true, get: function () { return createUserPoolsTokenProvider_1.createUserPoolsTokenProvider; } });
var createAWSCredentialsAndIdentityIdProvider_1 = require("./createAWSCredentialsAndIdentityIdProvider");
Object.defineProperty(exports, "createAWSCredentialsAndIdentityIdProvider", { enumerable: true, get: function () { return createAWSCredentialsAndIdentityIdProvider_1.createAWSCredentialsAndIdentityIdProvider; } });
